import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useFetchOptions from "../hooks/use-fetch-options.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { reasonOptions, guardOptions, placeOptions, neighborhoodOptions, streetOptions } = useFetchOptions();

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form id="search-form">

                    <div className={"mb-6"}>
                        <InputDateTime
                            id="dtStart"
                            label="Data/hora inicial *"
                            selected={filters.dtStart ? new Date(filters.dtStart) : null}
                            onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />
                    </div>

                    <div className={"mb-6"}>
                        <InputDateTime
                            id="dtEnd"
                            label="Data/hora final *"
                            selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                            onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />
                    </div>

                    <div className={"mb-6"}>
                        <SelectComponent
                            label='Status'
                            isMulti={false}
                            options={[
                                {label: "Realizado", value: 'true'},
                                {label: "Não realizado", value: 'false'}
                            ]}
                            value={filters.status}
                            onChange={(value) => setFilters(prev => ({...prev, status: value}))}
                            instanceId="status"
                            classNameWrapper={"w-full"}
                            isClearable={true}
                        />
                    </div>

                    <div className={"mb-6"}>
                        <SelectComponent
                            label='Natureza'
                            isMulti={true}
                            wrapValues={true}
                            options={reasonOptions}
                            value={filters.reason}
                            onChange={(value) => setFilters(prev => ({...prev, reason: value}))}
                            instanceId="reason"
                            classNameWrapper={"w-full"}
                        />
                    </div>

                    <div className={"mb-6"}>
                        <SelectComponent
                            label='Contingente'
                            isMulti={true}
                            wrapValues={true}
                            options={guardOptions}
                            value={filters.guard}
                            onChange={(value) => setFilters(prev => ({...prev, guard: value}))}
                            instanceId="guard"
                            classNameWrapper={"w-full"}
                        />
                    </div>

                    <div className={"mb-6"}>
                        <SelectComponent
                            label='Local pré-cadastrado'
                            isMulti={true}
                            wrapValues={true}
                            options={placeOptions}
                            value={filters.place}
                            onChange={(value) => setFilters(prev => ({...prev, place: value}))}
                            instanceId="place"
                            classNameWrapper={"w-full"}
                        />
                    </div>

                    <div className={"mb-6"}>
                        <SelectComponent
                            label='Bairro'
                            isMulti={true}
                            wrapValues={true}
                            options={neighborhoodOptions}
                            value={filters.neighborhood}
                            onChange={(value) => setFilters(prev => ({...prev, neighborhood: value}))}
                            instanceId="neighborhood"
                            classNameWrapper={"w-full"}
                        />
                    </div>

                    <div className={"mb-6"}>
                        <SelectComponent
                            label='Logradouro'
                            isMulti={true}
                            wrapValues={true}
                            options={streetOptions}
                            value={filters.street}
                            onChange={(value) => setFilters(prev => ({...prev, street: value}))}
                            instanceId="street"
                            classNameWrapper={"w-full"}
                        />
                    </div>

                </form>
            </div>
        </>
    );
};

export default Filters;